import React, { useState } from "react";
import styled from "styled-components";

import { ReactComponent as CloseIcon } from "../../../assets/cancel-outline.svg";
import { width } from "styled-system";
import { useDispatch } from "react-redux";
import { mergePatientDetails } from "../../../actions/radminUploads";
import { ReactComponent as MergeIcon } from "../../../assets/merge-icon.svg";
import { Spinner } from "react-bootstrap";

const Modal = styled.div`
  display: ${(props) => (props.showModal ? "flex" : "none")};
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  animation: changeWidth 8s ease-in-out infinite;
  background: rgba(12, 41, 69, 0.38);
  backdrop-filter: blur(10px);
  border-right: 1px solid whitesmoke;
`;

const ModalContentContainer = styled.div`
  width:min-content;
  margin: auto;
  border-radius: 4px;
  background-color: white;
  padding: 25px;
`;


const FilterMenuTitle = styled.div`
  margin-bottom: 0px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 30px;
  color: #0c2945;
`;


const Button = styled.button`
  width: 163px;
  height: 38px;
  background-color: ${(props) => props.bg};
  border-radius: 4px;
  border: ${(props) => props.border || 0};
  font: bold 14px "Open Sans", sans-serif;
  text-align: center;
  color: ${(props) => props.color};
  display: block;
  cursor: ${(props) => (props.disabled ? "" : "pointer")};
  opacity: ${(props) => (props.disabled ? "0.3" : "1")};
  &:hover {
    background: ${({ isPrimary }) => (isPrimary ? "transparent" : "#CFCFCF")};
    color: ${({ isPrimary }) => (isPrimary ? "#00aeef" : "white")};
    border: ${({ isPrimary }) =>
      isPrimary ? "2px solid #00AEEF" : "2px solid #CFCFCF"};
  }
`;

const Row = styled.div`
  display: flex;
  gap: ${(props) => props.gap || "10px"};
  justify-content: ${(props) => props.justifyContent || "space-between"};
`;




export const MergePatientsModal = (props) => {
  const { showModal, onClose, selectedPatients, setSelectedPatients, onSave } =
    props;

  const dispatch = useDispatch();
  const [selectedFields, setSelectedFields] = useState({});
  const [autoSelectedPatientIndex, setAutoSelectedPatientIndex] =
    useState(null);
  const [loading, setLoading] = useState(false);

  const handleFieldSelect = (field, value, patient, index) => {
    if (autoSelectedPatientIndex === null) {
      const newSelections = {
        mrn: { value: patient.mrn, patientId: patient.id },
        patientName: { value: patient.patientName, patientId: patient.id },
        date_of_birth: { value: patient.date_of_birth, patientId: patient.id },
        email: { value: patient.email, patientId: patient.id },
        phone_number: { value: patient.phone_number, patientId: patient.id },
        patientId: patient.id,
        first_name: { value: patient.first_name, patientId: patient.id },
        last_name: { value: patient.last_name, patientId: patient.id },
      };
      setSelectedFields(newSelections);
      setAutoSelectedPatientIndex(index);
    } else {
      if (field === "mrn") {
        setSelectedFields((prev) => ({
          ...prev,
          patientId: patient.id,
          [field]: { value, patientId: patient.id },
        }));
      } else if (field === "patientName") {
        setSelectedFields((prev) => ({
          ...prev,
          first_name: { value: patient.first_name, patientId: patient.id },
          last_name: { value: patient.last_name, patientId: patient.id },
          [field]: { value, patientId: patient.id },
        }));
      } else {
        setSelectedFields((prev) => ({
          ...prev,
          [field]: { value, patientId: patient.id },
        }));
      }
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    const finalPayload = Object.fromEntries(
      Object.entries(selectedFields).map(([key, obj]) => {
        if (key === "patientId") {
          return [key, obj];
        }
        return [key, obj?.value];
      })
    );

    dispatch(
      mergePatientDetails(
        finalPayload,
        selectedPatients
          ?.map((itm) => itm.id)
          ?.filter((itm) => itm !== selectedFields?.patientId)
      )
    ).then((res) => {
      setLoading(false);
      if (res) {
        onClose();
        setSelectedPatients([]);
        onSave();
      }
    });
  };

  return (
    <Modal showModal={showModal}>
      <ModalContentContainer>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <FilterMenuTitle>Merge Patient Records</FilterMenuTitle>
          <CloseIcon  
          style={{ cursor: "pointer"}}
          onClick={onClose} />
        </div>
        <div style={{ width: "100%" , marginBottom:'20px'}}>
          <h2
            style={{
              fontSize: "22px",
              fontWeight: 600,
              fontFamily: "Roboto Condensed",
              color: "#0C2945",
              marginBottom:'0px'
            }}
          >
            Choose data from the fields to combine the records into a single
            primary record
          </h2>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            gap: "59px",
            overflowX: "auto",
            paddingLeft: "20px",
            paddingBottom: "20px",
          }}
        >
          {selectedPatients?.map((patient, idx) => (
            <div
              key={patient.id || idx}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <strong style={{marginBottom:'10px', fontWeight:500, fontSize:'18px', fontFamily:'Roboto Condensed', color:'#0C2945'}}>Patient Record {idx + 1}</strong>

              {[
                ["mrn", patient.mrn, "PATIENT MRN"],
                ["patientName", patient.patientName, "PATIENT NAME"],
                ["date_of_birth", patient.date_of_birth, "DATE OF BIRTH"],
                ["email", patient.email, "EMAIL ADDRESS"],
                ["phone_number", patient.phone_number, "PHONE NUMBER"],
              ].map(([field, value, label]) => (
                <div
                  style={{ display: "flex", gap: "5px", position: "relative", marginBottom:'15px' }}
                >
                  <input
                    type="radio"
                    name={field}
                    checked={
                      selectedFields[field]?.value === value &&
                      selectedFields[field]?.patientId === patient.id
                    }
                    onChange={() =>
                      handleFieldSelect(field, value, patient, idx)
                    }
                    style={{ position: "absolute", top: "60%", left: "-20px" }}
                  />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#828282",
                        fontWeight: 400,
                      }}
                    >
                      {label ?? "-"}
                    </span>
                    <input
                      readOnly
                      style={{
                        fontSize: "12px",
                        background: "#F0F0F0",
                        border: "1px solid #D2D3D7",
                        padding: "9.5px 18px",
                        borderRadius: "4px",
                        width: "227px",
                        height: "39px",
                      }}
                      value={value ?? '-'}
                    />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        <Row
          style={{ width: "100%", marginTop: "20px" }}
          justifyContent="flex-end"
          gap="18px"
        >
          <Button
            color="#000000"
            border="2px solid #CFCFCF"
            bg="#FFF"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            bg="#00AEEF"
            color="#FFFFFF"
            isPrimary={true}
            disabled={false}
            onClick={handleSubmit}
          >
            <MergeIcon />
            {loading ? (
              <Spinner
                animation="border"
                role="status"
                size="sm"
                style={{ margin: "0 10px" }}
              />
            ) : (
              "Merge"
            )}
          </Button>
        </Row>
      </ModalContentContainer>
    </Modal>
  );
};
